import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, BarChart3, HardDrive, Building2, Users, Bug, ClipboardList, LogOut, Shield } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

const menuGroups = [
  {
    label: '모니터링',
    items: [
      { name: '대시보드', href: '/', icon: LayoutDashboard },
      { name: '기능 이용률', href: '/usage', icon: BarChart3 },
      { name: '스토리지', href: '/storage', icon: HardDrive },
    ],
  },
  {
    label: '관리',
    items: [
      { name: '조직', href: '/organizations', icon: Building2 },
      { name: '사용자', href: '/users', icon: Users },
      { name: '감사 로그', href: '/audit-logs', icon: ClipboardList },
    ],
  },
  {
    label: '지원',
    items: [
      { name: '오류 보고', href: '/bug-reports', icon: Bug },
    ],
  },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <aside className="w-60 bg-gray-900 flex flex-col shrink-0">
      {/* Logo */}
      <div className="px-5 py-6 flex items-center gap-2.5">
        <div className="size-8 bg-primary-600 rounded-lg flex items-center justify-center">
          <Shield className="size-4 text-white" />
        </div>
        <span className="text-lg font-bold text-white tracking-tight">MAIOS</span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2 space-y-6 overflow-y-auto">
        {menuGroups.map((group) => (
          <div key={group.label}>
            <p className="px-4 py-2 text-sm uppercase text-gray-500 font-semibold tracking-wider">
              {group.label}
            </p>
            <div className="space-y-0.5">
              {group.items.map((item) => (
                <NavLink
                  key={item.href}
                  to={item.href}
                  end={item.href === '/'}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-2.5 mx-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-gray-800 text-white'
                        : 'text-gray-400 hover:bg-gray-800 hover:text-white'
                    }`
                  }
                >
                  <item.icon className="size-[18px] shrink-0" />
                  {item.name}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* Logout */}
      <div className="border-t border-gray-800 px-2 py-3">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-2.5 mx-2 rounded-lg text-sm font-medium
            text-gray-400 hover:bg-gray-800 hover:text-white transition-colors w-full"
        >
          <LogOut className="size-[18px] shrink-0" />
          로그아웃
        </button>
      </div>
    </aside>
  );
}
